import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    const item = event.currentTarget.closest(".kapri-tree-item")
    item.classList.toggle("is-open")
    const icon = event.currentTarget.querySelector(".kapri-tree-icon")
    if (icon) icon.textContent = item.classList.contains("is-open") ? "−" : "+"
  }
}
